import * as types from "./types";

export const getRegistrationRequestsRequest = (payload) => ({
  type: types.GET_REGISTRATION_REQUESTS_REQUEST,
  payload,
});

export const getRegistrationRequestsResponse = (payload) => ({
  type: types.GET_REGISTRATION_REQUESTS_RESPONSE,
  payload,
});

export const getCompanyDetailsRequest = (payload) => ({
  type: types.GET_COMPANY_DETAILS_REQUEST,
  payload,
});

export const getCompanyDetailsSuccess = (payload) => ({
  type: types.GET_COMPANY_DETAILS_SUCCESS,
  payload,
});

export const getCompanyDetailsFailure = (payload) => ({
  type: types.GET_COMPANY_DETAILS_FAILURE,
  payload,
});

export const clearCompanyDetails = () => ({
  type: types.CLEAR_COMPANY_DETAILS,
});
